import axios from "@/axios";

export const namespaced = true

export const state = {
    faqs: []
}

export const getters = {
    faqs: (state) => state.faqs
}

export const mutations = {
    SET_FAQS: (state, response) => (state.faqs = response.data),
}

export const actions = {
    async getFaqs({ commit }) {
        commit('SET_FAQS', await axios.get("/api/faqs"))
    },

    async getFaqsPaginate({ commit }, pageInfo) {
        commit(
          "SET_FAQS",
          await axios.get(
            `/api/faqs/${pageInfo.pageNumber}/${pageInfo.pageCount}/${pageInfo.searchText}`
          )
        );
      },

    saveFaq({ commit}, model ) {
        return new Promise((resolve, reject) => {
            var data = {
                Id: model.id || 0,
                Question: model.question,
                Answer: model.answer
            };

           axios.post('/api/faqs', data,  { config:{ showToast: true, message: "FAQ saved successfully"}})
                .then(() => resolve())
                .catch((error) => reject("There was an error saving the item to the server."))
        });
    },

    removeFaq({ commit}, id ) {
        return new Promise((resolve, reject) => {
           axios.delete(`/api/faqs/${id}`,  { config:{ showToast: true, message: "FAQ deleted successfully"}})
                .then(() => resolve())
                .catch((error) => reject("There was an error removing the item to the server."))
        });
    }
}
